/**
 * Created by hp on 2017/7/17.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import LectureDialog from './lecture/LectureDialog';

import '../styles/GiftDialogTips.css';
import giftImage from '../images/gift.jpg';

class GiftDialogTips2 extends Component {
    constructor() {
        super();
        this.onNextHandle = this.onNextHandle.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    onRequestClose() {
        this.props.dispatch({
            type: 'LECTURE_HIDE_GIFT_BAR_TIPS'
        })
    }

    onNextHandle() {
        this.onRequestClose();
        this.props.dispatch({
            type: 'LECTURE_SHOW_GIFT_BAR'
        });
    }

    render() {
        const {showGiftBarTips} = this.props;
        return (
            <div className="gift-bar-tips">
                <LectureDialog
                    closeText="下一步"
                    onClick={this.onNextHandle}
                    show={showGiftBarTips}
                    onRequestClose={this.onRequestClose}>
                    <div className="gift-bar-tips-content">
                        <p className="image"><img src={giftImage} alt="giftImage"/></p>
                        <p className="title"><span>邀请好友 分享知识</span></p>
                        <p>1.购买课程，将链接分享给好友</p>
                        <p>2.好友点击领取，即可免费听课</p>
                        <p>3.在购买记录中查看赠礼详情</p>
                    </div>
                </LectureDialog>
            </div>
        )
    }
}

export default connect((state) => ({
    showGiftBarTips: state.lecture.showGiftBarTips,
}))(GiftDialogTips2);


// WEBPACK FOOTER //
// ./src/components/GiftDialogTips2.js